import { createSlice } from '@reduxjs/toolkit';
import {
  SearchStatus,
} from '../../constants';

export const detailsHandle = (state, { payload: { responseType, data } }) => ({
  ...state,
  [responseType]: data,
});

const initialState = {
  status: SearchStatus.INITIAL,
  currentTripId: null,
  cruiseDetails: {},
  ratesObj: {},
  ratesStatus: SearchStatus.INITIAL,
  cabinCategories: null,
  priceBreakdowns: {},
  availableCabins: null,
  deckLegends: null,
  error: {},
  stateroomTab: {
    tabNumber: 0,
    doScroll: false,
  },
};
const cruiseSlice = createSlice({
  name: 'cruise',
  initialState,
  reducers: {
    setStateroomTab: (state, { payload }) => ({
      ...state,
      stateroomTab: payload,
    }),
    setCurrentTripId: (state, { payload }) => ({
      ...state,
      currentTripId: payload,
    }),
    itineraryRequest: (state) => ({
      ...state,
      cruiseDetails: undefined,
      itineraryDetailError: undefined,
      itineraryDetailStatus: SearchStatus.SEARCHING,
    }),
    itinerarySuccess: (state, { payload }) => ({
      ...state,
      cruiseDetails: { ...payload },
      itineraryDetailError: payload.error,
      itineraryDetailStatus: SearchStatus.DONE,
    }),
    itineraryFailure: (state, { payload: { error } }) => ({
      ...state,
      itineraryDetailError: error,
      itineraryDetailStatus: SearchStatus.DONE,
    }),
    ratesRequest: (state) => ({
      ...state,
      ratesStatus: SearchStatus.SEARCHING,
    }),
    ratesSuccess: (state, { payload: { cabinCategories, cruiseLineAdvisories, errors } }) => ({
      ...state,
      cabinCategories,
      cabinCategoriesCruiseLineAdvisories: cruiseLineAdvisories,
      ratesStatus: SearchStatus.DONE,
      rateErrors: errors,
    }),
    ratesFailure: (state, { payload: { responseType, data } }) => ({
      ...state,
      [responseType]: data,
      ratesStatus: SearchStatus.DONE,
    }),
    setPricingRequestStatus: (state, action) => ({
      ...state,
      pricingStatus: action.payload,
    }),
    priceRequest: (state) => ({
      ...state,
    }),
    priceRequestTakeLatest: (state) => ({
      ...state,
    }),
    priceSuccess: (state, { payload }) => ({
      ...state,
      priceBreakdowns: { ...state.priceBreakdowns, ...payload },
    }),
    priceFailure: (state, action) => detailsHandle(state, action, 'error'),
    toggleViewAvailableCabinFor: (state, {
      payload: {
        itineraryId, cabinCategoryCode, cabinCategoryRateOptionCode,
      },
    }) => ({
      ...state,
      viewingAvailableCabinsFor: state.viewingAvailableCabinsFor
      && state.viewingAvailableCabinsFor.itineraryId === itineraryId
      && state.viewingAvailableCabinsFor.cabinCategoryCode === cabinCategoryCode
      && state.viewingAvailableCabinsFor.cabinCategoryRateOptionCode === cabinCategoryRateOptionCode
        ? {} : { itineraryId, cabinCategoryCode, cabinCategoryRateOptionCode },
    }),
    availableCabinsRequest: (state, { payload: { cabinNumber } }) => ({
      ...state,
      availableCabins: cabinNumber ? state.availableCabins : null,
      deckLegends: null,
      availableCabinsErrors: null,
      getSpecificCabinSearchStatus: cabinNumber ? SearchStatus.SEARCHING : SearchStatus.INITIAL,
    }),
    availableCabinsSuccess: (state, {
      payload: {
        cabins, errors, cruiseLineAdvisories, deckLegends,
      },
    }) => ({
      ...state,
      availableCabins: cabins,
      availableCabinsErrors: errors,
      specificCabin: null,
      availableCabinsCruiseLineAdvisories: cruiseLineAdvisories,
      deckLegends,
    }),
    getSpecificCabinSuccess: (state, { payload: { cabin } }) => ({
      ...state,
      specificCabin: cabin,
      getSpecificCabinSearchStatus: SearchStatus.DONE,
    }),
    resetGetSpecificCabinSearchStatus: (state) => ({
      ...state,
      getSpecificCabinSearchStatus: SearchStatus.INITIAL,
    }),
    availableCabinsFailure: (state, { payload: { errors } }) => detailsHandle(state, { payload: { data: errors, responseType: 'availableCabinsErrors' } }),
    getCruiseBenefitsRequest: (state) => ({
      ...state,
      cruiseBenefits: undefined,
      getCruiseBenefitsStatus: SearchStatus.SEARCHING,
    }),
    getCruiseBenefitsSuccess: (state, { payload: { data, error } }) => ({
      ...state,
      cruiseBenefits: data,
      cruiseBenefitsError: error,
      getCruiseBenefitsStatus: SearchStatus.DONE,
    }),
  },
});

export const searchDetails = (state) => state.cruise.searchDetails;
export const priceBreakdowns = (state) => state.cruise.priceBreakdowns;

export const {
  searchRegionDetails,
  itineraryRequest,
  itineraryFailure,
  itinerarySuccess,
  setCurrentTripId,
  ratesRequest,
  ratesSuccess,
  ratesFailure,
  setPricingRequestStatus,
  priceRequestTakeLatest,
  priceRequest,
  priceSuccess,
  priceFailure,
  toggleViewAvailableCabinFor,
  availableCabinsRequest,
  availableCabinsSuccess,
  availableCabinsFailure,
  getSpecificCabinSuccess,
  resetGetSpecificCabinSearchStatus,
  setIsFiltersEmpty,
  setStateroomTab,
  getCruiseBenefitsRequest,
  getCruiseBenefitsSuccess,
} = cruiseSlice.actions;
export default cruiseSlice.reducer;
